<div class="card" *ngIf="patientId">
    <div class="card-header bg-primary">Rischio di episodio di scompenso</div>
    <ngx-spinner name="provaSpinner" bdColor="rgba(196, 197, 198, 0.5)" size="medium" type="ball-spin-clockwise"
        [fullScreen]="false">
        <p style="color: white;margin-top: 4.5rem;"> Calcolo Rischio Scompenso... </p>
    </ngx-spinner>
    <div class="card-body" *ngIf="!visible" style="min-height: 270px;">

    </div>
    <div class="card-body" *ngIf="visible">
        <!-- Simple Risk Prediction Card (drop into a component) -->
        <div class="risk-card" role="region" aria-label="Rischio episodio di scompenso">
            <div class="risk-card__header">
                <div>
                    <div class="risk-card__title"><i class="fas fa-exclamation-triangle"
                            style="color:darkorange"></i>&nbsp;&nbsp;Rischio stimato
                    </div>
                    <!-- <div class="risk-card__subtitle">Orizzonte: 30 giorni</div> -->
                </div>
                <!-- Change class to badge--low / badge--med / badge--high -->
                <!-- <span class="badge badge-warning" aria-label="Classe di rischio: Moderato">Moderato</span> -->
            </div>


            <div class="risk-card__main">
                <div class="risk-card__score">
                    <ul style="list-style-type:none">
                        <li>
                            <div class="row col-md-12" style="font-size: 1.85rem">
                                <div class="col-md-4">
                                    <div class="risk-card__percent">

                                        {{prefix}} {{ riskPercent }}<span class="risk-card__pct">%</span>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <span style="font-size: 1.45rem" class="badge" [ngClass]="riskBadgeClass"
                                        [attr.aria-label]="'Classe di rischio: ' + riskLabel">{{ riskLabel }}</span>
                                </div>
                            </div>
                        </li>
                    </ul>




                    <!-- <div class="risk-card__hint">Rischio stimato</div> -->
                </div>

                <hr>

                <div class="risk-card__meta" aria-label="Affidabilità e copertura informativa">
                    <!-- <div class="kv">
                        <div class="kv__k">Affidabilità della stima</div>
                        <div class="kv__v">
                            <span class="meter" aria-hidden="true">
                                <span class="meter__fill" style="width:62%"></span>
                            </span>
                            <span class="kv__note">Confidence: <b>0.62</b></span>
                        </div>
                    </div>

                    <hr> -->



                    <div class="kv">
                        <div class="risk-card__title"><i class="fas fa-database"></i>&nbsp;&nbsp;Copertura informativa
                            <i class="fa fa-question-circle ml-2" style="font-size: 1.0em;" [pTooltip]="tooltipHtml"
                                [escape]="false"></i>
                        </div>
                        <ul>
                            <li>
                                <div class="kv__v">
                                    <span class="kv__note">Affidabilità della stima: <b>{{(nFeatures/totalFeature)*100 |
                                            number:'1.0-0' }}%</b> </span>
                                </div>
                            </li>
                            <li>
                                <div class="kv__v">
                                    <span class="kv__note">Informazioni disponibili: <b>{{nFeatures}}</b> /
                                        <b>{{totalFeature}}</b></span>
                                </div>
                            </li>
                        </ul>



                    </div>
                </div>
            </div>

            <hr *ngIf="features.length > 0">

            <div class="risk-card__section" aria-label="Fattori determinanti" *ngIf="features.length > 0">
                <div class="risk-card__title"><i class="fas fa-info-circle"></i>&nbsp;&nbsp;Fattori determinanti
                    <i class="fa fa-question-circle ml-2" style="font-size: 1.0em;"
                        pTooltip="Indicano le variabili che più hanno contribuito a stimare la percentuale di rischio"></i>
                </div>

                <div class="drivers">
                    <div class="drivers__col" aria-label="Fattori che aumentano il rischio">
                        <ul class="drivers__list">
                            <li class="driver" *ngFor="let riga of features; index as i">
                                <span class="driver__name">{{riga}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- <div class="risk-card__footer">
                <span class="footnote">
                    Nota: la “copertura informativa” indica quante variabili previste dal modello sono disponibili per
                    questa predizione.
                </span>
            </div> -->
        </div>
    </div>
</div>